// src/lib/inbox-ia-diag-label.js — Chantier 12 Cockpit PR1 (Lot A)
//
// Helper PUR (0 I/O, testable) : transforme le bloc `_diag` (booléens/enums, 0 PII)
// renvoyé par `inbox_suggest_reply` en sandbox + l'état d'escalade en UNE phrase
// LISIBLE pour un non-développeur. Le détail technique brut (chips détecteurs) reste
// affiché séparément, replié. Aucune dépendance React — pure fonction string.
//
// Shape de `_diag` (cf. api-inbox-ai-leaks.test.js) :
//   { intent, confidence, requires_human, model_used, itinerary_handled,
//     sensitive_override, thread_len, detected:{food_type, itinerary_form,
//     place_query, sensitive} }

// Intents Haiku (miroir du CHECK SQL inbox_ai_log.intent) → libellé FR lisible.
const INTENT_FR = {
  greeting: "un message d'accueil",
  access: "une demande d'accès",
  wifi: "une question WiFi",
  checkin: "l'arrivée (check-in)",
  checkout: "le départ (check-out)",
  availability: "une disponibilité",
  amenities: "les équipements",
  local_tips: "une recommandation locale",
  complaint: "une réclamation",
  incident: "un incident",
  refund: "un remboursement",
  billing: "un prix / une facturation",
  other: "un sujet divers",
};

/**
 * Libellé FR d'un intent (fallback : l'intent brut si inconnu).
 * @param {string} intent
 * @returns {string}
 */
export function intentLabelFR(intent) {
  if (typeof intent !== "string" || !intent) return "un sujet";
  return INTENT_FR[intent] || intent;
}

/**
 * Transforme `_diag` + l'état d'escalade en UNE phrase lisible.
 * Exemple : « Bien compris : l'arrivée (check-in) · réponse directe, pas d'escalade ».
 * En escalade : « Bien compris : un remboursement · escaladé (repris par un humain) ».
 *
 * @param {object|null} diag — le bloc `_diag` (ou null).
 * @param {boolean} [escalated=false] — true si la réponse a été escaladée.
 * @returns {string}
 */
export function diagToSentence(diag, escalated = false) {
  if (!diag || typeof diag !== "object") {
    return escalated ? "Escaladé (repris par un humain)." : "Réponse générée.";
  }
  const parts = [`Bien compris : ${intentLabelFR(diag.intent)}`];
  parts.push(
    escalated
      ? "escaladé (repris par un humain)"
      : "réponse directe, pas d'escalade",
  );
  if (diag.itinerary_handled === true) parts.push("itinéraire calculé");
  if (diag.sensitive_override === true) parts.push("sujet sensible détecté");
  return parts.join(" · ") + ".";
}

/**
 * Nom du modèle en clair (Haiku = tri rapide, Sonnet = rédaction).
 * @param {string} model
 * @returns {string}
 */
export function modelLabelFR(model) {
  if (typeof model !== "string" || !model) return "—";
  if (/haiku/i.test(model)) return "tri rapide";
  if (/sonnet/i.test(model)) return "rédaction";
  if (/deterministic/i.test(model)) return "réponse fixe (sécurité)";
  return model;
}
